import styled from 'util/style'

const Navigation = styled.div`
  display: flex;
`

export default Navigation
